import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {getUrlParameters} from '../../common/util/urlParameters';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchPartsByOrder = (order, params) => apiActionCreator({
  'endpoint': `/accessories/orders/${order}/parts${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_PARTS_BY_ORDER,
    ActionTypes.FETCHED_PARTS_BY_ORDER,
    [
      ActionTypes.FETCHED_PARTS_BY_ORDER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadStockToOrder = (order, data) => {
  const action = data.action === 'download' ? 'Descarga' : 'Reversión';
  return apiActionCreator({
    'endpoint': `/accessories/orders/${order}/parts/stock-download`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_STOCK_TO_ORDER,
      [
        () => {
          return {
            'type': ActionTypes.DOWNLOADED_STOCK_TO_ORDER,
            'payload': {order, 'action': data.action},
          };
        },
        MessageActions.addMessageBoxInfo(`${action} de la orden ${order} realizada satisfactoriamente`),
      ],
      [
        ActionTypes.DOWNLOADED_STOCK_TO_ORDER_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    data,
  });
};
